import type { ObraStatus } from '@obras/shared';

import { cn } from '../../lib/cn.js';

/**
 * A cor de cada situação no Mapa de Obras (design.md §4, Mapa): laranja em
 * andamento, preto paralisada, verde concluída, cinza cancelada.
 */
export const COR_NO_MAPA: Record<ObraStatus, string> = {
  em_andamento: 'var(--color-mapa-andamento)',
  paralisada: 'var(--color-mapa-paralisada)',
  concluida: 'var(--color-mapa-concluida)',
  cancelada: 'var(--color-mapa-cancelada)',
};

/*
 * A casinha, num quadro de 22×22: telhado em duas águas com beiral, paredes
 * retas e a porta vazada no pé, centrada. A base da casa é o ponto da obra.
 * As cores vêm de `.mapa-casa` e `.mapa-porta` (theme.css): a da situação pela
 * variável `--cor`, e o contorno branco que separa a casa de qualquer fundo —
 * é ele que faz a preta aparecer no tema escuro.
 */
const CASA = 'M11 2.25 20 10.25h-2.5v9.5h-13v-9.5H2Z';
const PORTA = 'M9.25 19.75v-5.5h3.5v5.5Z';

/** O desenho, como texto: o marcador é HTML montado pelo Leaflet. */
export const CASA_SVG = `<svg viewBox="0 0 22 22" width="22" height="22" aria-hidden="true"><path class="mapa-casa" d="${CASA}"/><path class="mapa-porta" d="${PORTA}"/></svg>`;

/**
 * A casinha em miniatura, na cor da situação: na lista ao lado do mapa, na
 * legenda e no painel da obra — a mesma forma do marcador, para a legenda
 * explicar o que se vê no mapa.
 */
export function CasaDaSituacao({
  status,
  className,
}: {
  status: ObraStatus;
  className?: string | undefined;
}) {
  return (
    <svg
      viewBox="0 0 22 22"
      aria-hidden
      className={cn('size-3.5 shrink-0', className)}
      style={{ ['--cor' as string]: COR_NO_MAPA[status] }}
    >
      <path className="mapa-casa" d={CASA} />
      <path className="mapa-porta" d={PORTA} />
    </svg>
  );
}
